import { Injectable } from '@angular/core';
import { Http, ResponseContentType} from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';
// import { Errorhandlers } from './errorhandlers';
import {EnvLoadService} from '../../../../env-load/env-load.service';

@Injectable()
export class PersonalSettingServices {
    private apiUrl = `${environment.apiUrl}/api/v1`;
    private companyId = global['loginUser'].curCmpnId;
    private notiUrl = `${this.envLoadService.notiUrl}/wx/v1`;

    constructor(private http: Http,
                private envLoadService: EnvLoadService) {
        this.companyId = global['loginUser'].curCmpnId;
    };

    /**
     * personal setting - Basic information
     * 사용자 정보 조회
     * Mothod : Get
     * API No : 7.01
     * /api/v1/{cmpnNo}/user
     **/
    getUserInformation(userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * personal setting - Basic information
     * timezone 수정
     * Mothod : Put
     * API No : 7.02
     * /api/v1/{cmpnNo}/user/timezone
     **/
    updateTimezone(putData: any, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/timezone`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * personal setting - Notification rule
     * notification rule 조회
     * Mothod : Get
     * API No : 7.07
     * /api/v1/{cmpnNo}/user/noti/{notiEvtCnfgNo}
     **/
    getNotiRuleList() {
        const url = `${this.apiUrl}/${this.companyId}/user/noti`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * personal setting - Notification rule
     * Icident Urgency 조회
     * Mothod : Get
     * API No : 7.09
     * /api/v1/{cmpnNo}/user/noti/tckt/urgency
     **/
    getUrgency() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/user/noti/tckt/urgency`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * personal setting - Basic information
     * contact mdthods 조회
     * Mothod : Get
     * API No : 7.11
     * /api/v1/{cmpnNo}/user/noti/cntcmeth
     **/
    getContactMethod() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/user/noti/cntcmeth`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * personal setting - Basic information
     * contac method 등록된 룰 조회
     * Mothod : Get
     * API No : 7.14
     * /api/v1/{cmpnNo}/user/cntcmeth/{cntcMethNo}/noti
     **/
    getRegisteredContactMethod(queryString) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/user/cntcmeth/noti${queryString}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * personal setting - Notification rule
     * notification rule 등록(List), 수정(List)
     * Mothod : Post, Put
     * API No : 7.17, 18
     * /api/v1/{cmpnNo}/user/noti
     **/
    saveNotificationRules(postData: any, type: string, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/noti`;

        if (type === 'Insert') {
            return this.http
                .post(url, JSON.stringify(postData))
                .toPromise()
                .then(res => res)
                .catch(this.handleError);
        } else if (type === 'Update') {
            return this.http
                .put(url, JSON.stringify(postData))
                .toPromise()
                .then(res => res)
                .catch(this.handleError);
        }
    }

    /**
     * personal setting - Notification rule
     * notification rule 삭제(List)
     * Mothod : Delete
     * API No : 7.19
     * /api/v1/{cmpnNo}/user/noti?notiRuleNos={notiRuleNos}
     **/
    deleteNotificationRule(notiRuleNos: string, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/noti${notiRuleNos}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * personal setting - Notification rule
     * notification rule 사용여부 설정
     * Mothod : Put
     * API No : 7.20
     * /api/v1/{cmpnNo}/user/noti?notiRuleNos={notiRuleNos}
     **/
    modifyNotificationRuleUseYn(postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/user/noti/use`;

        return this.http
            .put(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * personal setting - Basic information
     * contact method 등록
     * Mothod : Post
     * API No : 7.21
     * /api/v1/{cmpnNo}/user/cntcmeth
     **/
    createContact(postData: any, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/cntcmeth`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * personal setting - Basic information
     * contact method 수정
     * Mothod : Put
     * API No : 7.22
     * /api/v1/{cmpnNo}/user/cntcmeth
     **/
    updateContact(putData: any, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/cntcmeth`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * personal setting - Basic information
     * contact method 삭제
     * Mothod : Delete
     * API No : 7.23
     * /api/v1/{cmpnNo}/user/cntcmeth/{cntcMethNo}
     **/
    deleteContact(cntcMethNos: string, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/cntcmeth${cntcMethNos}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * personal setting - Basic information
     * contact meghod 중복체크
     * Mothod : Get
     * API No : 7.24
     * /api/v1/{cmpnNo}/user/cntcmeth/duplicate?cntcTypeCd={cntcTypeCd}&cndrCnfgSeq1Val={cndrCnfgSeq1Val}&cndrCnfgSeq2Val={cndrCnfgSeq2Val}
     **/
    dupliateCheckContactMethod(method) {
        const param = {
            cntcTypeCd: method.cntcTypeCd,
            cndrCnfgSeq1Val: method.cndrCnfgSeq1Val,
            cndrCnfgSeq2Val: method.cndrCnfgSeq2Val,
            userCntcMethNo: method.userCntcMethNo === null ? '' : method.userCntcMethNo
        };

        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/user/cntcmeth/duplicate?cntcTypeCd=${param.cntcTypeCd}&cndrCnfgSeq1Val=${param.cndrCnfgSeq1Val}&cndrCnfgSeq2Val=${param.cndrCnfgSeq2Val}&userCntcMethNo=${param.userCntcMethNo}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);

    }

    /**
     * personal setting
     * forwarding rule 등록
     * Mothod : Post
     * API No : 7.25
     * /api/v1/{cmpnNo}/user/forward
     **/
    createForwardingRule(postData: any, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/forward`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * personal setting
     * forwarding rule 수정
     * Mothod : Put
     * API No : 7.26
     * /api/v1/{cmpnNo}/user/forward/{forwardRuleNo}
     **/
    updateForwardingRule(putData: any, forwardRuleNo: string, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/forward/${forwardRuleNo}`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * personal setting - Basic information
     * forwarding rule 삭제
     * Mothod : Delete
     * API No : 7.27
     * /api/v1/{cmpnNo}/user/forward/{forwardRuleNo}
     **/
    deleteForwardingRule(forwardRuleNo: string, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/forward/${forwardRuleNo}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * personal setting
     * forwarding rule 조회
     * Mothod : Get
     * API No : 7.28
     * /api/v1/{cmpnNo}/user/forward
     **/
    getForwardingRule(userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/forward`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    createContactTelegram(postData: any, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/cntcmeth/telegram`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    updateContactTelegram(putData: any, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/cntcmeth/telegram`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    getWechatQRCode() {
        const url = `${this.notiUrl}/oauth/wechat?cmpnId=${global['loginUser'].curCmpnId}&svcId=1&extId=1&userId=${global['loginUser'].userId}&bspAccessToken=1`;
        return this.http
            .get(url, {responseType: ResponseContentType.Blob})
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    createNotiExt(postData: any, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/noti/ext`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    modifyNotiExt(postData: any, userNotiExtRuleNo, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/noti/ext/${userNotiExtRuleNo}`;
        return this.http
            .put(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    getNotiExt(userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/noti/ext`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    getNotiExtDetail(userNotiExtRuleNo, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/noti/ext/${userNotiExtRuleNo}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    deleteNotiExt(userNotiExtRuleNo: string, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/noti/ext/${userNotiExtRuleNo}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    getMsgSpec() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/user/noti/ext/msgspec`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    getNotiLimit(userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/noti/limit`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    postNotiLimit(postData: any, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/noti/limit`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);

    }

    putNotiLimit(putData: any, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/noti/limit`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);

    }

    deleteNotiLimit(notiLimitNo: string, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/noti/limit/${notiLimitNo}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }


    postNotiMute(postData: any, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/noti/mute`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);

    }

    getNotiMute(userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/noti/mute`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    deleteNotiMute(userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/noti/mute`;
        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    putVoicecallLang(putData: any, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'user';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/cntcmeth/ivrlang`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }

    /**
     * personal setting - personal information agreement
     * 개인정보 수집 등록
     * Mothod : Post
     * /api/v1/{cmpnNo}/user
     **/
    savePersonalInformationAgreement() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/user/agreements`;
        const reqBody = {
            agreement: "USER_TERMS"
        };

        return this.http
            .post(url, JSON.stringify(reqBody))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    validateLineUserOTP(otp: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/users/validate/lineuser?otp=${otp}`;
        return this.http
            .post(url, JSON.stringify({}))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/personalSetting.services.ts